module.exports = __webpack_public_path__ + "media/components/StreamChatAdmin/assets/stream-408c159b57ecb8771484a3dbd4bbb3f6.png";